import { RoutingPaths } from 'app/routes/routes'

import { isContractStatus } from 'entities/tour/libs/is-contract-status'
import { isTourDocumentCustomer } from 'entities/tour/models/document/is-tour-document-customer'

import type {
  TourDocumentOrderCardProps,
  TourDocumentOrderDto,
} from '../model/types'

const parseAmount = (value: string | null) => {
  if (value === null) return null

  const amount = Number(value)

  return Number.isFinite(amount) && amount >= 0 ? amount : null
}

export const mapTourDocumentOrder = (
  item: TourDocumentOrderDto,
): TourDocumentOrderCardProps => {
  const total = parseAmount(item.amount)
  const remaining = parseAmount(item.remaining_amount)
  const isCustomer = isTourDocumentCustomer({ canPay: item.can_pay })
  const hasFinancialData = isCustomer && total !== null && remaining !== null

  return {
    type: 'tour_document',
    id: item.id,
    hotel: item.hotel || item.title || '',
    destination: item.title || '',
    startDate: item.start_date || '',
    endDate: item.end_date || '',
    nights: item.nights || 0,
    tourists: item.tourists_count ?? undefined,
    total: hasFinancialData ? total : null,
    paid: hasFinancialData ? total - remaining : null,
    remaining: hasFinancialData ? remaining : null,
    status: item.status,
    detailPath:
      isContractStatus(item.status) && isCustomer
        ? RoutingPaths.tours.contract.path(item.id)
        : RoutingPaths.tours.documentDetails.path(item.id),
    image: item.cover || '',
  }
}
